import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";
import { successToast, errorToast } from "../../../Utils/toast";
import { WhereHouseList } from "../../../redux/services/WhereHouseService/wherehouse.Services";
import { formatDate } from "../../../Utils/formatters"
import { ActiveUserList } from "../../../redux/services/User Services/User.Services";
import { ActiveProductList } from "../../../redux/services/ProductService/product.Services";
import { createInventryTransfer } from "../../../redux/services/InventryTransferService/inventory.Services"
function CreateInventryData() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [warehouseList, setWarehouseList] = useState([]);
    const [user, setUser] = useState([]);
  const [productList, setProductList] = useState([]);
  const [formData, setFormData] = useState({
     vendor_id: "",
    fromwarehouseName: "",
    towarehouseName: "",
    product: "",
    quantity: "",
    transferPrice: "",
    transferDate: new Date().toISOString().split("T")[0],
    remark: "",

  });
  useEffect(() => {
    fetchWarehouse();
    fetchProduct();
  }, []);

  const fetchWarehouse = async () => {
    try {
      const res = await WhereHouseList({
        page: 1,
        search: "",
        status: "",
      });

      if (res.success) {
        const warehouseData = res?.data?.data || res?.data || [];
        setWarehouseList(warehouseData);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const fetchProduct = async () => {
    try {
      const res = await ActiveProductList();

      if (res?.success) {
        setProductList(res?.data || []);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: value,
         ...(name === "fromwarehouseName" && {
      towarehouseName: "",
    }),
      };

      // Agar From Warehouse change hua
      if (
        name === "fromwarehouseName" &&
        Number(value) === Number(prev.towarehouseName)
      ) {
        updated.towarehouseName = "";
      }

      // Agar To Warehouse change hua
      if (
        name === "towarehouseName" &&
        Number(value) === Number(prev.fromwarehouseName)
      ) {
        updated.fromwarehouseName = "";
      }

      return updated;
    });

    // Error clear
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };
  const selectedProduct = productList.find(
    (item) => item.id == formData.product
  );
  const validateForm = () => {
    const newErrors = {};
  if (!formData.vendor_id) {
      newErrors.vendor_id = "Vendor is required ";
    }
    if (!formData.fromwarehouseName) {
      newErrors.fromwarehouseName = ["Please select From Warehouse"];
    }

    if (!formData.towarehouseName) {
      newErrors.towarehouseName = ["Please select To Warehouse"];
    }

    if (
      formData.fromwarehouseName &&
      formData.fromwarehouseName === formData.towarehouseName
    ) {
      newErrors.towarehouseName = [
        "From and To Warehouse cannot be same",
      ];
    }

    if (!formData.product) {
      newErrors.product = ["Please select Product"];
    }
    if (
      selectedProduct &&
      Number(formData.quantity) > Number(selectedProduct.min_stock_level)
    ) {
      newErrors.quantity = [
        `Only ${selectedProduct.min_stock_level} units available`
      ];
    }
    if (!formData.quantity) {
      newErrors.quantity = ["Please enter quantity"];
    } else if (Number(formData.quantity) <= 0) {
      newErrors.quantity = ["Quantity must be greater than zero"];
    }

    if (!formData.transferDate) {
      newErrors.transferDate = ["Please select transfer date"];
    }

    setErrors(newErrors);

    return newErrors;
  };
    useEffect(() => {
      const fetchUser = async () => {
        try {
          const res = await ActiveUserList();
          if (res?.success) {
            setUser(res?.data || []);
          } else {
            errorToast(res?.message || "Failed to fetch users");
          }
        } catch (error) {
          console.error("Error fetching users:", error);
          errorToast(
            error?.response?.data?.message || "Something went wrong while fetching users"
          );
        }
      };
      fetchUser();
    }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }
    setLoading(true);
    try {
      const payload = {
        from_warehouse_id: Number(formData.fromwarehouseName),
        to_warehouse_id: Number(formData.towarehouseName),
        transfer_date: formData.transferDate,
        remark: formData.remark,
        items: [
          {
            product_id: Number(formData.product),
            quantity: Number(formData.quantity),
            transfer_price: Number(formData.transferPrice),
            remark: formData.itemRemark,
          },
        ],
      };
      const res = await createInventryTransfer(payload);
      if (res?.success) {
        successToast(res?.message || []);
        setFormData({
          fromwarehouseName: "",
          towarehouseName: "",
          quantity: "",
          product: "",
          transferDate: "",
          remark: ""

        });
        setErrors({});

        navigate("/transfer-inventroy-list")
        dispatch(refreshProductList());
      } else {
        // Show error toast with message from API
        errorToast(res?.message || "Failed to create warehouse");
      }
    } catch (error) {
      console.error("Error creating warehouse:", error);
      if (error?.response?.status === 422) {
        setErrors(error.response.data.errors || {});
        errorToast("Please check the form for errors");
      } else {
        errorToast(error?.response?.data?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main_page">

      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex justify-content-between align-items-center w-100">
              <div className="page-header">
                <div>
                  <h3 className="page-title"> Purchase Product Transfer </h3>
                </div>
              </div>
              <div className="d-flex flex-wrap gap-2 justify-content-end">
                <button className="add-btn" onClick={() => navigate(-1)}>Back</button>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit} className="row g-3">


             <div className="col-md-6">
          <label>Vendor <span className="text-light">*</span></label>
          <select
            name="vendor_id"
            value={formData.vendor_id}
            onChange={handleChange}
            className={`form-control custumform ${errors?.vendor_id ? "is-invalid" : ""}`}
          >
            <option value="">Select Vendor</option>
            {user.map((users) => (
              <option key={users.id} value={users.user_id || users.id}>
                {users.name || users.mobile}
              </option>
            ))}
          </select>
          {errors?.vendor_id && (
            <div className="invalid-feedback">
              {errors.vendor_id}
            </div>
          )}
        </div>
            <div className="col-md-6">
              <label>
                From Warehouse <span className="text-danger">*</span>
              </label>
              <select
                name="fromwarehouseName"
                value={formData.fromwarehouseName}
                onChange={handleChange}
                className={`form-control custumform ${errors?.fromwarehouseName ? "is-invalid" : ""
                  }`}
              >
                <option value="">
                  {formData.fromwarehouseName
                    ? "Select To Warehouse"
                    : "Please select From Warehouse first"}
                </option>
                {warehouseList
                  ?.filter(
                    (item) => Number(item.id) !== Number(formData.towarehouseName)
                  )
                  .map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.warehouse_name}
                    </option>
                  ))}
              </select>

              {errors?.fromwarehouseName && (
                <div className="invalid-feedback d-block">
                  {errors.fromwarehouseName[0]}
                </div>
              )}
            </div>

            {/* Warehouse Code */}
            <div className="col-md-6">
              <label>
                To Warehouse <span className="text-danger">*</span>
              </label>

              <select
                name="towarehouseName"
                value={formData.towarehouseName}
                onChange={handleChange}
                disabled={!formData.fromwarehouseName}
                className={`form-control custumform ${errors?.towarehouseName ? "is-invalid" : ""
                  }`}
              >
                <option value="">Select Warehouse</option>

                {warehouseList
                  ?.filter(
                    (item) => Number(item.id) !== Number(formData.fromwarehouseName)
                  )
                  .map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.warehouse_name}
                    </option>
                  ))}
              </select>

              {errors?.towarehouseName && (
                <div className="invalid-feedback d-block">
                  {errors.towarehouseName[0]}
                </div>
              )}
            </div>
            <div className="col-md-6">
              <label>Please Select Product <span className="text-danger">*</span></label>
              <select
                name="product"
                value={formData.product}
                onChange={handleChange}
                className={`form-control custumform ${errors?.product ? "is-invalid" : ""
                  }`}
              >
                <option value="">Select Product</option>

                {productList?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.product_name||item.name}
                  </option>
                ))}
              </select>
              {errors?.product && (
                <div className="invalid-feedback d-block">
                  {errors.product}
                </div>
              )}
            </div>


            <div className="col-md-6">
              <label>quantity <span className="text-danger">*</span></label>
              <input
                type="text"
                name="quantity"
                value={formData.quantity}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setFormData((prev) => ({
                    ...prev,
                    quantity: value,
                  }));
                  if (errors.quantity) {
                    setErrors((prev) => ({
                      ...prev,
                      quantity: null,
                    }));
                  }
                }}
                className={`form-control custumform ${errors?.quantity ? "is-invalid" : ""}`}
                placeholder="Enter quantity"
                maxLength={10}
              />
              {selectedProduct && (
                <small className="text-primary">
                  Available Stock : {selectedProduct.min_stock_level}
                </small>
              )}

              {errors?.quantity && (
                <div className="invalid-feedback d-block">
                  {errors.quantity[0]}
                </div>
              )}
            </div>

            <div className="col-md-6">
              <label>
                Transfer Date
                <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                name="transferDate"
                value={formatDate(formData.transferDate)}
                onChange={handleChange}
                className={`form-control custumform ${errors?.transferDate ? "is-invalid" : ""
                  }`}
              />

              {errors?.transferDate && (
                <div className="invalid-feedback d-block">
                  {errors.transferDate[0]}
                </div>
              )}
            </div>
            {/* <div className="col-md-6">
  <label>
    Transfer Price <span className="text-danger">*</span>
  </label>

  <input
    type="text"
    name="transferPrice"
    value={formData.transferPrice}
    onChange={handleChange}
    className="form-control custumform"
    placeholder="Enter Transfer Price"
  />
</div> */}
            <div className="col-md-12">
              <label>Remark</label>

              <textarea
                rows="3"
                name="remark"
                value={formData.remark}
                onChange={handleChange}
                className="form-control custumform"
                placeholder="Enter Remark"
              />
            </div>


            {/* SUBMIT */}
            <div className="col-12 text-end">
              <button
                type="submit"
                className="add-btn"
                disabled={loading}
              >
                {loading ? "Transfering..." : "Transfer"}
              </button>
            </div>
          </form>
        </div>
      </div>



    </div>

  );
}

export default CreateInventryData;